<template>
  <div
    class="idx-skeleton"
    :style="{
      width: width ? `${width}px` : '100%',
      height: height ? `${height}px` : '25px',
      borderRadius: radius ? `${radius}px` : '0',
    }"
  >
    <div
      v-if="inner"
      style="background: #ffffff;"
      :style="{
        width: width ? `${Number(width - 100)}px` : '100px',
        height: height ? `${Number(height - 100)}px` : '100px',
        borderRadius: radius ? `${radius}px` : '0',
      }"
    ></div>
  </div>
</template>

<script>
import backgroundImage5 from '../../../assets/street-background.jpg';

export default {
  props: {
    width: { type: String },
    height: { type: String },
    radius: { type: String },
    inner: { type: String },
  },
  data() {
    return {
      imgs: [],
    };
  },
  mounted() {
    this.imgs = [backgroundImage5];
  },
};
</script>

<style lang="scss" scoped>
.idx-skeleton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, rgba(130, 130, 130, 0.2)),
    color-stop(18%, rgba(130, 130, 130, 0.3)),
    color-stop(33%, rgba(130, 130, 130, 0.2))
  );
  background: linear-gradient(
    to right,
    rgba(130, 130, 130, 0.2) 8%,
    rgba(130, 130, 130, 0.3) 18%,
    rgba(130, 130, 130, 0.2) 33%
  );
  background-size: 998px 100px;
  animation: wave-lines 1.75s infinite ease-out;
}

@keyframes wave-lines {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/idx-skeleton/index.vue